import TabBlock from "../parts/tab_blocks";
import Modal from "../parts/modals";

document.addEventListener("DOMContentLoaded", () => {
    const agencyTabs = document.querySelector(".js-brand-tabs");
    if (agencyTabs) {
        new TabBlock(agencyTabs).init();
    }
});
